import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
Vue.use(VueRouter);

import xhqjRouter from './modules/xhqj';
import xsdtRouter from './modules/xsdt';
import xsjlRouter from './modules/xsjl';
import ybjRouter from './modules/ybj';
import loginRouter from './modules/login';
import errorRouter from './modules/error';

export const constantRoutes = [
    {
        path: '/',
        component: () => import('@/views/dashboard/index')
    },
    xhqjRouter,
    xsdtRouter,
    xsjlRouter,
    ybjRouter,
    loginRouter,
    errorRouter
];

const createRouter = () => new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes
});
const router = createRouter();

router.beforeEach((to, from, next) => {
    if (!store.state.isLogin && to.name != '登录页') {
        next({
            path: '/login?from=' + encodeURIComponent(location.href)
        });
    } else {
        next(() => {
            store.commit("SET_KEEP_ALIVE", ["addProject"])
        });
    }
});


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;

